<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' ref='form' :inline='true' :model='queryForm' class='query-form' label-width='80px'
            size='small' @submit.native.prevent>
            <el-form-item label='转盘名称'>
                <el-input v-model='queryForm.turntableName'></el-input>
            </el-form-item>
            <el-form-item label='是否激活'>
                <el-select v-model='queryForm.isActive' size='small'>
                    <el-option v-for='(item, index) in yesNoEnumList' :key='index' :label='item.value' :value='item.key'>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon='el-icon-search' size='small' type='primary' @click='getMarketTurntableList'>查询
                </el-button>
                <el-button icon='el-icon-refresh' size='small' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button icon='el-icon-plus' size='small' type='primary' @click='addMarketTurntable'>新建
                    </el-button>
                    <el-button :disabled='multipleSelection.length != 1' icon='el-icon-edit' plain size='small'
                        type='warning' @click='editMarketTurntable(null)'>修改
                    </el-button>
                    <el-button :disabled='multipleSelection.length <= 0' icon='el-icon-delete' plain size='small'
                        type='danger' @click='deleteMarketTurntable(null)'>删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate' :http-request='upload' :show-file-list='true' action='#'
                        class='upload-demo'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span class='icon-box' title='搜索' @click='search'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMarketTurntableList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span class='icon-box' @click='refreshMarketTurntableList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :cell-style="{ padding: '9px' }" :data='marketTurntableList' :header-cell-style="{ padding: '10px' }"
                :header-row-style="{ height: '10px' }" :row-style="{ height: '9px' }" border height='100%' row-key='id'
                size='small' @selection-change='handleSelectionChange'>
                <el-table-column align='center' type='selection' width='60'></el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='转盘名称'
                    prop='turntableName'></el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='是否激活' prop='isActive'>
                    <template slot-scope='scope'>
                        <div>{{ computeYesNo(scope.row.isActive) }}</div>
                    </template>
                </el-table-column>
                <el-table-column align='center' fixed='right' label='操作' width='400'>
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click="editMarketTurntableItem(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">奖项设置</span>
                            </div>
                            <div @click="turntableRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">抽奖记录</span>
                            </div>
                            <div @click='onActive(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>激活</span>
                            </div>
                            <div @click='editMarketTurntable(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMarketTurntable(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination :current-page.sync='currentPage' :page-size='pageSize' :page-sizes='[10, 20, 50, 100]'
                    :pager-count='7' :total='totalNum' background layout='total, sizes, prev, pager, next, jumper'
                    @size-change='sizeChange' @current-change='currentChange'>
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title='marketTurntableStates[marketTurntableState]' :visible.sync='showDialog' width='60%'
                @close='closeDialog'>
                <div>
                    <el-form ref='marketTurntableForm' :inline='true' :model='marketTurntable' :rules='rules'
                        label-width='120px' size='small'>
                        <el-form-item label='转盘名称' prop='turntableName'>
                            <el-input style='width: 200px' v-model='marketTurntable.turntableName'
                                :disabled="marketTurntableState == 'check'" size='small'></el-input>
                        </el-form-item>
                        <el-form-item clearable label='是否激活' prop='isActive'>
                            <el-select style='width: 200px' v-model='marketTurntable.isActive' :disabled="marketTurntableState == 'check'"
                                size='small'>
                                <el-option v-for='(item, index) in yesNoEnumList' :key='index' :label='item.value'
                                    :value='item.key'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='显示奖项' prop='showItem'>
                            <el-select clearable style='width: 200px' v-model='marketTurntable.showItem' :disabled="marketTurntableState == 'check'"
                                size='small'>
                                <el-option :value='1' label="是"></el-option>
                                <el-option :value='0' label="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='显示纪录' prop='showRecord'>
                            <el-select clearable style='width: 200px' v-model='marketTurntable.showRecord' :disabled="marketTurntableState == 'check'"
                                size='small'>
                                <el-option :value='1' label="是"></el-option>
                                <el-option :value='0' label="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='开始时间' prop='startTime'>
                            <el-date-picker
                                style='width: 200px'
                                v-model="marketTurntable.startTime"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择开始日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label='结束时间' prop='endTime'>
                            <el-date-picker
                                style='width: 200px'
                                v-model="marketTurntable.endTime"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择结束日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="活动规则">
                            <el-input type="textarea" :rows="6" style='width: 530px' v-model='marketTurntable.drawRule'
                                :disabled="marketTurntableState == 'check'"></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot='footer' class='flex justify-end'>
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button v-if="marketTurntableState != 'check'" type='primary' @click='submitForm'>确定
                    </el-button>
                </div>
            </el-dialog>
            <el-drawer title="奖项管理" :visible.sync="turntableItemDrawer" direction="rtl" size="70%"
                :before-close="turntableItemDrawerClose">
                <MarketTurntableItem :turntableId="turntableId" ref="marketTurntableItem" />
            </el-drawer>
            <el-drawer title="抽奖纪录" :visible.sync="turntableRecordDrawer" direction="rtl" size="70%"
                :before-close="turntableRecordClose">
                <MarketTurntableRecord :turntableId="turntableId" ref="marketTurntableRecord" />
            </el-drawer>
        </div>
    </div>
</template>

<script>
import {
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Delete24Regular,
    Edit24Regular,
    Eye24Regular
} from '@v2icons/fluent';
import { ArrowDown, ArrowUp, GridDots, Printer, Refresh, Search } from '@v2icons/tabler';
import { deleteFun, exprotExcel, get, importDate, importTemplate, post } from '@/utils/request.js';
import MarketTurntableItem from './MarketTurntableItem.vue'
import MarketTurntableRecord from './MarketTurntableRecord.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MarketTurntableItem,
        MarketTurntableRecord
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketTurntableList();
                this.getMarketTurntableList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketTurntableList();
                this.getMarketTurntableList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            yesNoEnumList: [],
            turntableItemDrawer: false,
            turntableId: '',
            turntableRecordDrawer: false,

            queryForm: {
                turntableName: '', //转盘名称
                isActive: '' //是否激活
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketTurntableState: 'add',
            marketTurntableStates: {
                add: '新建转盘',
                check: '查看转盘',
                edit: '修改转盘'
            },

            multipleSelection: [],
            marketTurntableList: [],
            marketTurntable: {
                turntableName: '', //转盘名称
                isActive: '', //是否激活
                drawRule: '', //活动规则
                showItem: '', //显示奖项
                showRecord: '', //显示纪录
                startTime: '', // 开始时间
                endTime: '', // 结束时间
            },
            btnLoading: false,

            rules: {
                turntableName: [{ required: true, message: '转盘名称不能为空', trigger: 'blur' }],
                isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                drawRule: [{ required: true, message: '活动规则不能为空', trigger: 'blur' }],
                showItem: [{ required: true, message: '显示奖项不能为空', trigger: 'blur' }],
                showRecord: [{ required: true, message: '显示纪录不能为空', trigger: 'blur' }],
                startTime: [{ required: true, message: '活动开始时间不能为空', trigger: 'blur' }],
                endTime: [{ required: true, message: '活动结束时间不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getMarketTurntableList();
        this.getYesNoEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMarketTurntableList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketTurntableList = [];
        },
        resetDialog() {
            this.marketTurntableState = 'add';
            this.showDialog = false;
            this.queryForm = {
                turntableName: '', //转盘名称
                isActive: '' //是否激活
            };
            this.getMarketTurntableList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketTurntable = {
                turntableName: '', //转盘名称
                isActive: '', //是否激活
                drawRule: '', //活动规则
                showItem: '', //显示奖项
                showRecord: '', //显示纪录
                startTime: '', // 开始时间
                endTime: '', // 结束时间
            };
        },
        submitForm() {
            if (this.marketTurntableState == 'add') {
                this.$refs.marketTurntableForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/turntable/add`, { ...this.marketTurntable }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.marketTurntableState == 'edit') {
                this.$refs.marketTurntableForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.marketTurntable.itemList
                        post(`/market/turntable/edit`, { ...this.marketTurntable }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMarketTurntable() {
            this.showDialog = true;
            this.marketTurntableState = 'add';
        },
        checkMarketTurntable(marketTurntableId) {
            console.log(marketTurntableId);
            this.currentMarketTurntableId = marketTurntableId;

            this.getMarketTurntableById();
            this.showDialog = true;
            this.marketTurntableState = 'check';
        },
        editMarketTurntable(marketTurntableId) {
            console.log('marketTurntable', marketTurntableId);
            if (marketTurntableId) {
                this.currentMarketTurntableId = marketTurntableId;
                this.getMarketTurntableById();
            } else {
                this.marketTurntable = { ...this.marketTurntable, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketTurntableState = 'edit';
        },
        deleteMarketTurntable(marketTurntableId) {
            let ids = '';
            if (marketTurntableId) {
                ids = marketTurntableId;
            } else {
                ids = this.multipleSelection.map((marketTurntable) => marketTurntable.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/turntable/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketTurntableList();
                            this.getMarketTurntableList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketTurntableList() {
            this.resetMarketTurntableList();
            this.getMarketTurntableList();
        },
        getMarketTurntableList(query = {}) {
            this.loading = true;
            get(`/market/turntable/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketTurntableList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMarketTurntableById() {
            get(`/market/turntable/get`, { id: this.currentMarketTurntableId }).then((res) => {
                if (res.success) {
                    this.marketTurntable = { ...this.marketTurntable, ...res.marketTurntable };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketTurntableList() {
            //this.btnLoading = true;
            exprotExcel(`/market/turntable/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/turntable/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/turntable/importData`, formData);
            this.refreshMarketTurntableList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketTurntableList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketTurntableList();
        },

        // 打开奖项管理
        editMarketTurntableItem(id) {
            this.turntableId = id
            this.$nextTick(() => {
                this.$refs['marketTurntableItem'].getMarketTurntableItemList();
            })

            this.turntableItemDrawer = true
        },

        // 关闭奖项管理
        turntableItemDrawerClose() {
            this.turntableId = ''
            this.turntableItemDrawer = false
        },

        // 查看抽奖记录
        turntableRecord(id) {
            this.turntableId = id
            this.$nextTick(() => {
                this.$refs['marketTurntableRecord'].getMarketTurntableRecordList();
            })
            this.turntableRecordDrawer = true
        },

        turntableRecordClose() {
            this.turntableId = ''
            this.turntableRecordDrawer = false
        },

        // 获取是否枚举
        getYesNoEnum() {
            get('/mpp/utils/getEnum', { enumType: 'yes_no' }).then((res) => {
                if (res.success) {
                    this.yesNoEnumList = res.enumList;
                }
            });
        },

        // 计算是否
        computeYesNo(type) {
            for (let i = 0; i < this.yesNoEnumList.length; i++) {
                if (this.yesNoEnumList[i].key == type) {
                    return this.yesNoEnumList[i].value;
                }
            }
        },

        onActive(id) {
            this.$confirm('是否激活此转盘?', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                get('/market/turntable/activate', {
                    turntableId: id,
                }).then((res) => {
                    if (res.success) {
                        this.$message({
                            type: 'success',
                            message: '激活成功!'
                        });
                        this.getMarketTurntableList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                })
            }).catch(() => {

            });
        }
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    &>div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>